'use strict';

var React = require('react');
var cs = require('classnames');
require('../Box/Box.js');
require('../../style-inject.es-dcee06b6.js');
var components_Icon_Icon = require('../Icon/Icon.js');
var icons_LoaderOutline = require('../../icons/LoaderOutline.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var cs__default = /*#__PURE__*/_interopDefaultLegacy(cs);

const Spinner = ({ size = 24, className = "", isSpinning = true, }) => {
    const classes = cs__default['default'](className, { "ss-animate-spin": isSpinning });
    return React__default['default'].createElement(components_Icon_Icon, { size: size, svg: icons_LoaderOutline, className: classes });
};

module.exports = Spinner;
